import React, { useState } from 'react';
import { Button, ConfirmModal, Marker } from 'components/UI';
import { onDeleteCustomTender } from 'redux_store/modules/tenderCard';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import selector from 'redux_store/selectors/dictionary/marker';
import { onSetMarker } from 'redux_store/modules/tender';
import { trashRed as TrashRed, edit as Edit } from 'theme/icon';
import { StarFilled, StarOutlined } from '@ant-design/icons';
import { withRouter } from 'react-router-dom';
import styles from './styles.scss';

const CustomTenderActions = props => {
  const { tenderData, markers } = props;
  const [isConfirmOpen, handleSetIsConfirmOpen] = useState(false);
  const { tenderEdit, tenderDelete, markerEdit } = tenderData.access;
  return (
    <div className={styles.tenderActions}>
      {tenderEdit && (
        <Button
          onClick={() => {
            props.history.push(`/ct/${tenderData.tenderId}`);
          }}
        >
          <Edit alt="edit" />
        </Button>
      )}
      {markerEdit && (
        <Marker id={tenderData.tenderId} markers={markers} onSetMarker={props.onSetMarker}>
          <Button
            icon={
              <>
                {tenderData.markerColor ? (
                  <StarFilled
                    style={tenderData.markerColor ? { color: tenderData.markerColor } : {}}
                    className={styles.marker_icon}
                  />
                ) : (
                  <StarOutlined
                    style={tenderData.markerColor ? { color: tenderData.markerColor } : {}}
                    className={styles.marker_icon}
                  />
                )}
              </>
            }
          />
        </Marker>
      )}
      {tenderDelete && (
        <Button
          icon={TrashRed}
          onClick={() => {
            handleSetIsConfirmOpen(true);
          }}
        >
          <TrashRed alt="delete" />
        </Button>
      )}
      {isConfirmOpen && (
        <ConfirmModal
          isOpen
          onAfterOpen={() => {}}
          onRequestClose={() => handleSetIsConfirmOpen(false)}
          onRequestSubmit={() => {
            props.onDeleteCustomTender(tenderData.tenderId);
            props.history.push('/');
          }}
          text="Вы действительно хотите удалить тендер?"
        />
      )}
    </div>
  );
};

CustomTenderActions.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  tenderData: PropTypes.objectOf(PropTypes.any).isRequired,
  onDeleteCustomTender: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  history: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default withRouter(connect(selector, { onDeleteCustomTender, onSetMarker })(CustomTenderActions));
